module.exports = __webpack_public_path__ + "media/images/sandbox/screencast-aa24b3fd72851ef698745f1021250732.jpg";